import { Http } from "../axios/interceptors";

export const allCategoryProductsByCompany = async (param) =>
  Http("GET", `/CategoryProducts/GetList?`, param);

export const getCategoryProduct = async (id) =>
  Http("GET", `/CategoryProducts/Get?idCompanyCategoryProducts=${id}`);

export const createOrEditCategoryProduct = async (body, id = null) =>
  id
    ? Http("PUT", `/CategoryProducts/Update`, null, body)
    : Http("POST", "/CategoryProducts/Create", null, body);

export const deleteCategoryProduct = async (id) =>
  Http("DELETE", `/CategoryProducts/Delete?idCompanyCategoryProducts=${id}`);
